import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock } from 'lucide-react';
import { Button } from '../../components/ui/Button';
interface AssessmentHeaderProps {
  currentQuestion: number;
  totalQuestions: number;
  elapsedMs: number;
  onExit: () => void;
  onPrevious?: () => void;
  canGoPrevious: boolean;
  answeredIndices?: Set<number>;
}
export function AssessmentHeader({
  currentQuestion,
  totalQuestions,
  elapsedMs,
  onExit,
  onPrevious,
  canGoPrevious,
  answeredIndices = new Set()
}: AssessmentHeaderProps) {
  const minutes = Math.floor(elapsedMs / 60000);
  const seconds = Math.floor(elapsedMs % 60000 / 1000);
  const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  const progressPercentage = currentQuestion / totalQuestions * 100;
  return <header className="fixed top-0 left-0 right-0 bg-white border-b border-slate-200 shadow-sm flex flex-col z-50" data-id="element-719" data-mp="2k2c4g2l3g6r8">
      {/* Mobile Progress Bar (Top edge) */}
      <div className="h-1 w-full bg-slate-100 sm:hidden" data-id="element-720" data-mp="2ovdk4ct4kabv">
        <motion.div className="h-full bg-indigo-600" initial={{
        width: 0
      }} animate={{
        width: `${progressPercentage}%`
      }} transition={{
        duration: 0.3
      }} data-id="element-721" data-mp="21a2n3hti4qvl" />
        
      </div>

      <div className="h-16 flex items-center justify-between px-4 sm:px-6" data-id="element-722" data-mp="2a2w4plwf82cm">
        {/* Left: Exit & Previous */}
        <div className="flex items-center gap-2 sm:gap-4 w-1/3" data-id="element-723" data-mp="258rxd1j8tsb0">
          <Button variant="ghost" size="sm" onClick={onExit} className="text-slate-500 hover:text-slate-900 hover:bg-slate-100" data-id="element-724" data-mp="2jyhc5zk9dutr">
            
            Stoppen
          </Button>

          {onPrevious && <Button variant="ghost" size="sm" onClick={onPrevious} disabled={!canGoPrevious} className="flex text-slate-500 hover:text-slate-900 hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-725" data-mp="2sz5rqypaw38r">
            
              <ArrowLeft className="w-4 h-4 sm:mr-1.5" data-id="element-726" data-mp="yoiliucm4b2x" />
              <span className="hidden sm:inline" data-id="element-727" data-mp="ulw0pdeczqf8">Vorige</span>
            </Button>}
        </div>

        {/* Center: Progress & Badge */}
        <div className="flex-1 flex flex-col items-center justify-center" data-id="element-728" data-mp="2trf8nx8of6ja">
          <div className="flex items-center gap-2 mb-1.5" data-id="element-729" data-mp="2ypgtonpnxfxe">
            <div className="text-slate-700 text-sm font-bold" data-id="element-730" data-mp="33o1rkghfznio">
              Vraag {currentQuestion} van {totalQuestions}
            </div>
          </div>

          {/* Desktop Dots */}
          <div className="hidden sm:flex items-center gap-1.5 justify-center" data-id="element-731" data-mp="3coghxu99jst1">
            {Array.from({
            length: totalQuestions
          }).map((_, i) => {
            const isCurrent = i === currentQuestion - 1;
            const isAnswered = answeredIndices.has(i);
            return <div key={i} className={`
                    w-2 h-2 rounded-full transition-all duration-300
                    ${isCurrent ? 'bg-indigo-600 scale-125 ring-2 ring-indigo-100' : isAnswered ? 'bg-indigo-300' : 'bg-slate-200'}
                  `} data-id="element-732" data-mp="3mgm7kxc1ly52" data-mpi={i} />;
          })}
          </div>
        </div>

        {/* Right: Timer */}
        <div className="w-1/3 flex justify-end" data-id="element-733" data-mp="1or7cj1518om0">
          <div className="flex items-center gap-2 text-slate-600 bg-slate-100 px-3 py-1.5 rounded-full font-mono text-sm font-medium border border-slate-200" data-id="element-734" data-mp="1ool30vykzz15">
            <Clock className="w-4 h-4 text-slate-400" data-id="element-735" data-mp="1fr2dpfdwmyjg" />
            {timeString}
          </div>
        </div>
      </div>
    </header>;
}